/** Ba trạng thái mà mọi màn hình tải dữ liệu đều phải có: tải, trống, lỗi. */

import Icon, { type TenIcon } from './Icon'
import { thongDiepLoi } from '../api/loi'

/* ── Đang tải ────────────────────────────────────────────────────────────── */

/**
 * Khung xương giữ đúng hình dạng nội dung sắp tới.
 *
 * Dùng cái này thay chữ "Đang tải…": trên mạng 3G ở công trường, khoảng chờ
 * dài tới vài giây và một trang trắng trơn làm người dùng tưởng app hỏng rồi
 * bấm lung tung.
 */
export function XuongDong({ so = 4, cao }: { so?: number; cao?: boolean }) {
  return (
    <div style={{ display: 'grid', gap: 'var(--k3)' }}
         aria-busy="true" aria-label="Đang tải dữ liệu">
      {Array.from({ length: so }, (_, i) => (
        <div key={i} className={`khung-xuong ${cao ? 'the-lon' : ''}`} />
      ))}
    </div>
  )
}

/* ── Trống ───────────────────────────────────────────────────────────────── */

export function OTrong(
  { tieu_de, mo_ta, icon = 'hop-trong', children }: {
    tieu_de: string
    mo_ta?: string
    icon?: TenIcon
    children?: React.ReactNode
  },
) {
  return (
    <div className="o-trong">
      <span className="o-trong-icon"><Icon ten={icon} size={24} /></span>
      <strong>{tieu_de}</strong>
      {mo_ta && <p>{mo_ta}</p>}
      {children}
    </div>
  )
}

/* ── Lỗi ─────────────────────────────────────────────────────────────────── */

/**
 * Lỗi khi TẢI dữ liệu — khác `RanhGioiLoi` (lỗi khi RENDER).
 *
 * Luôn kèm nút thử lại: ở công trường phần lớn lỗi là mất sóng chốc lát, và
 * bắt nhân viên tải lại cả ứng dụng chỉ để gọi lại một endpoint là thừa.
 */
export function HopLoi({ loi, thuLai }: { loi: unknown; thuLai?: () => void }) {
  return (
    <div className="thong-bao-loi" role="alert">
      <strong>Chưa tải được dữ liệu</strong>
      <p style={{ margin: '4px 0 0' }}>{thongDiepLoi(loi)}</p>
      {thuLai && (
        <button type="button" className="nut-phu"
                style={{ marginTop: 'var(--k3)' }} onClick={thuLai}>
          Thử lại
        </button>
      )}
    </div>
  )
}
